import { atom } from 'jotai';
import { seasonsAtom } from '@/atoms/queries/seasons';
import { optionsAtomCallback } from '@/utils/atoms/generic';

// `seasonsAtom` is referenced inside the read (not captured at module load) so a
// circular-import ordering can't freeze an `undefined` data atom into the closure.
export const eventDataSeasonsOptionsAtom = atom(async get =>
  (await optionsAtomCallback(seasonsAtom, 'name', 'season_id', get)).reverse(),
);
